import React from 'react'
const ProductFeatureAssociationData = (props) => {
    const {product_name, data} = props;
    let assFeatureHtml = ''
    if( data.feature_list.length > 0 ){
        assFeatureHtml = data.feature_list.map((featureData,i) => 
            <span key={i} className="badge badge-secondary me-2">{featureData?.label}</span>
        )
    }
    return(
        <>
            <div className="row mb-3">
                <label className="col-lg-3 fw-semibold text-muted">
                    {product_name}
                </label>
                <div className="col-lg-9">
                    {assFeatureHtml}
                </div>
            </div>
        </>
    );
}
const ProductFeatureAssociation = (props) => {
    const {product_feature_association_data} = props;
    let productFeatureAssHtml = '';
    if(Object.keys(product_feature_association_data).length > 0){
        productFeatureAssHtml = Object.entries(product_feature_association_data).map(([key, associationData], i) => (
            <ProductFeatureAssociationData 
                key={i}
                product_name={key}
                data={associationData}
            />
        ));
    }
    return (
        <>
            <div className='row'>
                <div className='col-md-12 px-6 pt-3'>
                    <div className="card card-flush border border-dashed border-gray-500">
                        <div className="card-header">
                            <h3 className="card-title align-items-start flex-column">
                                <span className="card-label fw-bold text-gray-800">
                                    Product Features Association
                                </span>
                                <span className="text-gray-400 mt-1 fw-semibold fs-6">
                                    Total 2 data are available
                                </span>
                            </h3>
                        </div>
                        <div className="separator"></div>
                        <div className="card-body p-5">
                            {productFeatureAssHtml}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ProductFeatureAssociation